module.exports = __webpack_public_path__ + "img/st-cb6-1-010.6770558f.gif";